const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the Explore container Directive which holds the content and people explore directives
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('exploreContainer', ['Application', 'Authorization', 'AccessHelper', function (Application, Authorization, AccessHelper) {
    return {
      restrict: 'E',
      template: require('../../templates/directives/explore-container.html'),
      controller: ['$scope', 'Navigation', function ($scope, Navigation) {
          var self = this;
          self.allowOrder = AccessHelper.isAllowed(['explore', 'order_content'], null, ['admin']);
          Application.notifications.updateUserNotifications();
          self.user = Authorization.getAuthToken().user;
          self.active = 'content';
          self.searchQueries = [];
          self.clearSearch = false;

          self.content = {
            loading: false,
            category: null
          };

          self.people = {
            view: 'grid',
            onSearch: function(){console.log('New function not yet loaded from people search directive.')}
          };

          const path = Navigation.getPath();
          if (path === '/people') {
            self.active = 'people';
          }
        }],
      controllerAs: 'container'
    };
  }]);
